// extracted by mini-css-extract-plugin
export default {"team-member-wrapper":"TeamPOC_team-member-wrapper__YKCew","checkbox-space":"TeamPOC_checkbox-space__D4UsP","add-btn":"TeamPOC_add-btn__6BCcb"};